module.exports = __webpack_public_path__ + "img/class.96927894.png";